import React from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';
import { BUILDER } from 'shared/abilities';
import { section } from '../decorators';
import stylesGlobal from '../../../theme/facility-globals.scss';

const FacilityGroupSection = ({ children }) => {
  const [headerText, facilities] = React.Children.toArray(children);

  return (
    <div className={`${stylesGlobal.section} ${stylesGlobal.sectionNoPadBtm}`}>
      <Container>
        <Row>
          <Col md={12} sm={24} className="color-primary-foreground">
            {headerText}
          </Col>
          <Col md={12} sm={24}>
            {facilities}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

FacilityGroupSection.propTypes = {
  children: PropTypes.node.isRequired,
};

const component = section(
  { name: 'Facility Group', category: 'Locations' },
  {
    subsections: [
      { accepts: ['HeaderText'] },
      { accepts: ['FacilityGroupWidget'] },
      { accepts: ['NearbyLocations'] },
      { accepts: ['FacilityAmenities'] },
    ],
    defaults: [
      ['HeaderText', {
        rawContentState: {
          blocks: [
            {
              key: 'db2mm',
              text: 'Header Text Goes Here',
              type: 'header-two',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      }],
      ['FacilityGroupWidget'],
    ],
  },
)(FacilityGroupSection);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
